module.exports = __webpack_public_path__ + "media/images/flags/WF-bddd48631f45c1ffac59840e39dc5591.svg";